export default "__VITE_ASSET__DVi2o2PO__"